import { AxiosResponse } from 'axios'
import compress from 'graphql-query-compress'
import { axiosClient } from 'lib/core/services/magento/client'
import { CATALOG_FILTER } from 'lib/core/resources/constants'

export interface AttributeSettings {
  attribute_code: string
  position: number
  collapsed: boolean
}

export type AttributeSettingsMap = Partial<Record<string, AttributeSettings>>

export const fetchAttributeSettings = async (): Promise<AttributeSettingsMap> => {
  return axiosClient(compress(`
    {
      getVisitureAttributesFields {
        attribute_code
        position
        collapsed
      }
    }
  `)).then((res: AxiosResponse<{ data: { getVisitureAttributesFields: AttributeSettings[] }}>) => {
    return res.data.data.getVisitureAttributesFields.reduce((obj: AttributeSettingsMap, el) => {
      el.position = parseInt(`${el.position}`)
      if (el.attribute_code === 'visiture_category_filter') {
        obj[CATALOG_FILTER.CATEGORY] = el
      } else {
        obj[el.attribute_code] = el
      }
      return obj
    }, {})
  })
}
